// Fonts
import 'zignal-landscape/lib/styles/fonts/roboto.css';

import merge from 'lodash/merge';
import BaseTheme from 'zignal-landscape/lib/Light';
import WidgetsTheme from 'zignal-widgets/lib/Light';

// Theme CSS
import 'zignal-landscape/lib/Light.css';
import 'zignal-widgets/lib/Light.css';

// Components
import App from 'components/App/themes/AppLight.css';
import CheckerModalForm from
  'containers/StoryAndSourceChecker/components/CheckerModalForm/themes/CheckerModalFormLight.css';
import ForgotForm from 'components/ForgotForm/themes/ForgotFormLight.css';
import LoginForm from 'containers/Login/components/LoginForm/themes/LoginFormLight.css';
import LegacyLoginForm from 'containers/Login/components/LegacyLoginForm/themes/LegacyLoginFormLight.css';
import LayoutApp from 'components/LayoutApp/themes/LayoutAppLight.css';
import Dropdown from 'containers/Notification/components/Dropdown/themes/DropdownLight.css';
import DropdownItem from 'containers/Notification/components/DropdownItem/themes/DropdownItemLight.css';
import Badge from 'containers/Notification/components/Badge/themes/BadgeLight.css';
import EmptyTable from 'components/TableLoader/components/EmptyTable/themes/EmptyTableLight.css';
import TableLoader from 'components/TableLoader/themes/TableLoaderLight.css';
import PrettyPrintButton from 'components/PrettyPrintButton/themes/PrettyPrintButtonLight.css';
import SharedLinkRow from 'containers/DashboardLinkAccess/components/SharedLinkRow/themes/SharedLinkRowLight.css';
import StoryAndSourceChecker from 'containers/StoryAndSourceChecker/themes/StoryAndSourceCheckerLight.css';
import SourceCheckerForm from
  'containers/StoryAndSourceChecker/components/SourceCheckerForm/themes/SourceCheckerFormLight.css';
import StoryCheckerForm from
  'containers/StoryAndSourceChecker/components/StoryCheckerForm/themes/StoryCheckerFormLight.css';
import Table from 'components/Table/themes/TableLight.css';
import TableIcon from 'components/TableIcon/themes/TableIconLight.css';
import ZccAdd from 'containers/Zccs/components/ZccAdd/themes/ZccAddLight.css';
import ZccListItem from 'containers/Zccs/components/ZccListItem/themes/ZccListItemLight.css';
import ZccForm from 'containers/Zccs/components/ZccForm/themes/ZccFormLight.css';
import ConfidenceSlider from 'components/ConfidenceSlider/themes/ConfidenceSliderLight.css';
import BotIntelligenceThemes from 'containers/BotIntelligence/LightTheme';
import HomePageThemes from 'containers/HomePage/LightTheme';
import InternalAdminsThemes from 'containers/InternalAdminsTab/LightTheme';
import DefaultLocationsThemes from 'containers/DefaultLocations/LightTheme';
import UserFormThemes from 'containers/UserForm/LightTheme';
import ZccInstallationsThemes from 'containers/ZccInstallations/LightTheme';
import BaseWizardThemes from 'containers/BaseWizard/LightTheme';
import BulkEditionThemes from 'containers/BulkEdition/LightTheme';
import TierOverrideThemes from 'containers/TierOverride/LightTheme';
import TwitterImports from 'containers/TwitterImports/themes/TwitterImportsLight.css';
import DownloadMenu from 'components/DownloadMenu/themes/DownloadMenuLight.css';
import Menu from 'components/DownloadMenu/themes/MenuLight.css';
import SyndicatedStoryModal from 'containers/SyndicatedStoryModal/themes/SyndicatedStoryModalLight.css';
import WidgetEmbedModal from 'containers/WidgetEmbedModal/themes/WidgetEmbedModalLight.css';
import StoriesTable from 'containers/SyndicatedStoryModal/components/StoriesTable/themes/StoriesTableLight.css';
import ActionsMenu from
  'containers/SyndicatedStoryModal/components/StoriesTable/components/ActionsMenu/themes/ActionsMenuLight.css';
import ReadingList from
  'containers/SyndicatedStoryModal/components/StoriesTable/components/ReadingList/themes/ReadingListLight.css';
import SyndicateModalConfirmation from
  // eslint-disable-next-line max-len
  'containers/SyndicatedStoryModal/components/StoriesTable/components/SyndicateModalConfirmation/themes/SyndicateModalConfirmation.css';
import SourceCheckerResult from
  'containers/StoryAndSourceChecker/components/SourceCheckerResult/themes/SourceCheckerResultLight.css';
import StoryCheckerDetail from
  'containers/StoryAndSourceChecker/components/StoryCheckerDetail/themes/StoryCheckerDetailLight.css';
import ResultList from
  'containers/StoryAndSourceChecker/components/ResultList/themes/light.css';
import AdminSettings from 'containers/AdminSettings/themes/light.css';
import DataSources from 'containers/DataSources/themes/light.css';
import CheckboxResultFilter from
  'containers/StoryAndSourceChecker/components/ResultList/components/CheckboxResultFilter/themes/light.css';
import Story from 'containers/StoryAndSourceChecker/components/StoryCheckerResult/themes/StoryLight.css';
import StoryContentMSIChecker from
  'containers/StoryAndSourceChecker/components/StoryContentMSIChecker/themes/StoryContentMSICheckerLight.css';
import ReadingListStoriesSortDropdown from 'components/ReadingList/themes/ReadingListStoriesSortDropdownLight.css';
import SideBarNav from 'containers/SideBarNav/themes/SideBarNavLight.css';
import SmartFilterPane from 'containers/SmartFilterPane/themes/SmartFilterPaneLight.css';
import StaleIcon from 'components/StaleIcon/themes/StaleIconLight.css';
import OverviewPage from 'containers/TrendingStoriesOverview/components/OverviewPage/themes/light.css';
import StoryDetails from 'containers/TrendingStoriesOverview/components/StoryDetails/themes/light.css';
import TweetsPage from 'containers/TrendingStoriesOverview/components/TweetsPage/themes/light.css';
import OverviewStory from 'containers/TrendingStoriesOverview/components/OverviewStory/themes/light.css';
import InfoBox from 'containers/TrendingStoriesOverview/components/InfoBox/themes/light.css';
import AdminManagement from 'containers/AdminManagement/AdminManagementLight.css';
import DiscoverHistorics from 'containers/DiscoverHistorics/LightTheme.js';
import InteractiveIconHeader from 'components/InteractiveIconHeader/themes/InteractiveIconHeaderLight.css';
import FilterSideBar from 'containers/FilterSideBar/themes/FilterSideBarLight.css';
import FilterSideBarElementBase from 'containers/FilterSideBar/FilterSideBarElementBase/themes/FilterSideBarElementLight.css';
import TooltipSideBar from 'containers/FilterSideBar/TooltipSideBar/themes/TooltipSideBarLight.css';
import MfeSearchDropDown from 'components/MfeSearchDropDown/themes/MfeSearchDropDownLight.css';
import MfeHeader from 'components/MfeHeader/themes/MfeHeaderLight.css';
import MfeModal from 'components/MfeModal/themes/MfeModalLight.css';
import SelectionModal from 'containers/SelectionModal/themes/SelectionModalLight.css';
import Language from 'components/Language/themes/LanguageDark.css';
import LanguageSelector from 'components/LanguageSelector/themes/LanguageSelectorDark.css';
import NavBar from 'containers/NavBar/themes/NavBarLight.css';
import SideBar from 'containers/SideBar/themes/SideBarLight.css';
import DashboardPageHeader from 'containers/DashboardPageHeader/themes/DashboardPageHeaderLight.css';

export default merge({}, BaseTheme, WidgetsTheme, {
  App,
  CheckerModalForm,
  ForgotForm,
  LoginForm,
  LegacyLoginForm,
  LayoutApp,
  Dropdown,
  DropdownItem,
  Badge,
  EmptyTable,
  TableLoader,
  SharedLinkRow,
  StoryAndSourceChecker,
  SourceCheckerForm,
  StoryCheckerForm,
  Table,
  TableIcon,
  ZccAdd,
  ZccListItem,
  ZccForm,
  ConfidenceSlider,
  DownloadMenu,
  Menu,
  SyndicatedStoryModal,
  PrettyPrintButton,
  WidgetEmbedModal,
  StoriesTable,
  ActionsMenu,
  ...BotIntelligenceThemes,
  ...HomePageThemes,
  ...InternalAdminsThemes,
  ...DefaultLocationsThemes,
  ...UserFormThemes,
  ...TierOverrideThemes,
  ...ZccInstallationsThemes,
  ...BaseWizardThemes,
  ...BulkEditionThemes,
  ...DiscoverHistorics,
  TwitterImports,
  SourceCheckerResult,
  StoryCheckerDetail,
  ResultList,
  AdminSettings,
  DataSources,
  CheckboxResultFilter,
  Story,
  StoryContentMSIChecker,
  ReadingList,
  SyndicateModalConfirmation,
  ReadingListStoriesSortDropdown,
  SideBarNav,
  SmartFilterPane,
  StaleIcon,
  OverviewPage,
  StoryDetails,
  TweetsPage,
  OverviewStory,
  InfoBox,
  AdminManagement,
  InteractiveIconHeader,
  FilterSideBar,
  FilterSideBarElementBase,
  TooltipSideBar,
  MfeSearchDropDown,
  MfeHeader,
  MfeModal,
  SelectionModal,
  Language,
  LanguageSelector,
  NavBar,
  SideBar,
  DashboardPageHeader
});
